<template id="MangoPageBlock">
    <div class="vats-price num_buy">
        <Loader v-if="loader.data > 0"/>
        <template v-else>
            <div class="num_buy__row">
              <div
                  class="num_buy__top num_buy__cell"
                  :class="showOnlyNumbers && !readOnly ? 'num_buy__top--wide' : ''">
                <VatsSelect
                    :items="vatsItems"
                    :currentVats="currentVats"
                    :vatsSelecTitle="vatsSelectTitle"
                    @change="changeVats"
                    v-if="!hideSelectVats"
                />

                  <div
                      class="tabs-section__wrapper"
                      v-if="Object.keys(anchorList).length > 0"
                  >
                      <div class="tabs-section__tabs">
                          <button
                              class="tabs-section__tab"
                              :class="{ 'tabs-section__tab--active': index === activeTab }"
                              type="button"
                              v-for="(item, index) in anchorList"
                              :key="item.code"
                              @click.prevent="anchorClickHandler(index)"
                          >
                              {{ item.name }}
                          </button>
                      </div>
                  </div>
                <div class="numbers">
                  <div class="num_buy__types">
                    <NumbersFilter
                        ref="filter"
                        :showRegionSelect="needShowSelectCity"
                        :regionSelectMultiple="regionSelectMultiple"
                        :showDetailSearch="showDetailSearch"
                        :branches="branches"
                        :counters="counters"
                        v-model:category="category"
                        :isDemoVats="isDemoVats"
                        :motivationPopoverContent="chain !== 'virtual_number' ? motivationPopoverContent : null"
                        @selectBranch="showSelectBranchModal"
                        @applyFilter="applyFilter"
                    />
                  </div>
                  <div class="numbers-type_main" data-element="numbers-container">
                      <Loader v-if="reloading" />
                      <template v-else>
                        <template v-if="!isEmpty">
                            <NumbersGroup
                              :showChoseRandomButton="false"
                              :isMobile="isMobile"
                              :group="group"
                              :branch="branchesGrouped[group.branchId]"
                              :category="category"
                              :isDemoVats="isDemoVats"
                              :canBuyCount="canBuyCount"
                              :viewMode="viewMode"
                              :isFMC="isFMC"
                              :groupingCount="isGrouping ? groupingCount : 0"
                              :numbersCountBeforeRegLink="numbersCountBeforeRegLink"
                              :patterns="patterns"
                              :loading="loader.page[group.id]"
                              :blockLoading="loader.blocks"
                              :key="group.id"
                              v-for="(group, i) in displayNumbersGroups"
                              :hidden="activeNumberGroup.indexOf(i) === -1"
                              :hideShowMoreBtn="numbersBlockLimit > 0"
                              @toggleActive="toggleActive(i)"
                              @load="load(group)"
                              @addNumbers="(numbers, params) => addNumbers(numbers, params)"
                              @removeNumbers="(numbers, params) => removeNumbers(numbers, params)"
                              @changeProviderTariff="(provider, tariff) => changeProviderTariff(provider, tariff)"
                          />
                            <a v-if="isMobileNumbers" href="/shop/numbers_mobile/">Ещё номера</a>
                        </template>
                        <template v-if="displayEmptyMessage">
                          <div class="empty-numbers" data-element="empty-numbers">
                            <div class="row">
                              <div class="col-md-3 empty-numbers--icon">
                                <span class="icon-mobile-phone"></span>
                              </div>
                              <div class="col-md-9 empty-numbers--text">
                                <div v-html="displayEmptyMessage"/>
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                </div>
                <template v-if="stepNote && !reloading">
                  <a name="step_note" id="step_note"></a>
                  <div class="step-note fs-sm text-gray" v-html="stepNote"/>
                </template>
              </div>
              <div class="num_buy__btm num_buy__cell">
                <Aside v-if="!showOnlyNumbers">
                  <template v-slot:miniCart>
                    <MiniCart
                        ref="cart"
                        :cart="cart"
                        :motivationPopoverContent="chain === 'virtual_number' ? motivationPopoverContent : null"
                        :loading="nextStepLoading"
                        @remove="(item) => removeCartItem(item)"
                        @submit="submit"
                    />
                  </template>
                </Aside>
                <div class="num_buy__visitors">
                  <NowBuying
                    :count="nowBuyingCount"
                    :timeFromShow="nowBuyingTimeFromShow"
                    :wrapper="false"
                  />
                </div>
              </div>
            </div>
        </template>
        <ArcticModal id="number-page__modal">
        </ArcticModal>
    </div>
</template>
<script>

import NumbersPageBlock from '../App.vue';
import NowBuying from '../../numbers-page/components/NowBuying.vue';

export default {
    extends: NumbersPageBlock,
    name: "NumbersPageBlock",
    components: {
      NowBuying,
    },
    data() {
        return {
            activeTab: 0,
        }
    },
    computed: {
        needShowSelectCity() {
            if (!this.showRegionSelect) {
                return false;
            }

            let codes = {
                '8800': '8800',
                'numbers_mobile': 'numbers_mobile'
            };

            if (this.anchorList.length > 0) {
                return !codes[this.anchorList[this.activeTab].code];
            }

            return !codes[this.anchor];
        },
    },
    methods: {
        anchorClickHandler(index) {
            if (this.activeTab !== index) {
                this.getBranchesPreset(this.anchorList[index].code);
            }

            this.activeTab = index;

        }
    }
}
</script>